<template>
<div style="display: inline-block;">

    <template>
      <v-btn
        @click.stop="dialog = true"
        color="red" class="white--text"
        dark
      >
        <span>削除</span></v-btn>
    </template>



    <v-dialog
      v-model="dialog"
      max-width="600px"
    >

      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-9 text-center"
          color="mygreen"
          dark>スタッフ情報削除</v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="text-left" cols="12">スタッフ情報を削除してもよろしいでしょうか？<br>
この操作は取消し出来ません。</v-col>
            </v-row>

          </v-container>
        </v-card-text>

        <v-card-actions class="pb-6">
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            @click="dialog = false">戻る</v-btn>
          <v-btn dark
            color="mygreen"
            @click="mydelete()">決定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import myMixin from '@/mixin.js';
import axios from 'axios';
import {mapGetters} from 'vuex'
/* eslint-disable */



export default {

    mixins: [myMixin],
    created() {
        console.log('%ccreated: DialogKyukaDelete.vue', mycolor.created);
    },


    // datas
    data() {
            return {
                dialog: false,
            }
    },
    computed: {
        ...mapGetters(['user', 'user_name', 'is_admin']),
    },
    methods: {
        /* eslint-disable */
        mydelete(){
            console.log('mydelete()');

            this.$emit('delete-item');
            this.dialog = false;

        }  // mydelete()

        /* eslint-disable */

    }, // methods
}
</script>

<style scoped>
/deep/ .v-input__append-inner{
    margin: auto !important;
}
/deep/ .row > div {
/*    height: 70px; */
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .theme--light.v-input{
    margin-top: -8px;
}
/deep/ .v-select__slot{
    height: 40px;
}
/deep/ .v-dialog > .v-card > .v-card__text{
    padding-bottom: 0px;
}
/deep/ .v-toolbar__content{
    text-align: center;
}
</style>
